<template>
  <div class="project-vip-user-info-widget-edit relative">
    <menu-item label="背景填充">
      <menu-fill :target="model.background" target-key="background" />
    </menu-item>
    <menu-item label="PC端" size-tip="（建议尺寸：1280px x 280px）">
      <menu-background-image :target="model.background" target-key="background" class="mt-2" />
    </menu-item>
    <menu-item label="移动端" size-tip="（建议尺寸：370px x 126px）">
      <menu-background-image :target="model.mobileBackground" target-key="mobileBackground" class="mt-2" />
    </menu-item>
    <menu-item label="文字颜色">
      <menu-fill :target="model.textColor" target-key="textColor" solid-color />
    </menu-item>
    <menu-item label="进度条背景">
      <menu-fill :target="model.progressBg" target-key="progressBg" solid-color />
    </menu-item>
    <menu-item label="进度条填充">
      <menu-fill :target="model.progressFill" target-key="progressFill" solid-color />
    </menu-item>
    <menu-item label="按钮填充色">
      <menu-fill :target="model.btnBg" target-key="btnBg" />
    </menu-item>
    <menu-item label="按钮文字色">
      <menu-fill :target="model.btnTextColor" solid-color target-key="btnTextColor" />
    </menu-item>
    <menu-item label="按钮文案">
      <base-input v-model="model.btnText" size="small" />
    </menu-item>
    <menu-item label="默认等级ICON">
      <menu-background-image :target="model.levelIcon" target-key="levelIcon" />
    </menu-item>
    <menu-item label="等级名称">
      <menu-switch label="开启" v-model="model.showLevelName" target-key="showLevelName" />
    </menu-item>
    <nav-edit class="mt-6" :site="site" label="按钮跳转事件" :target="model.jumpLink" />
    <remove-btn class="mt-4" />
  </div>
</template>

<script>
import MenuItem from "~/components/menu/menuItem.vue"
import MenuFill from "~/components/menu/menuFill.vue"
import MenuBackgroundImage from "~/components/menu/menuBackgroundImage.vue"
import NavEdit from '~/site/components/navEdit.vue'
import MenuSwitch from "~/components/menu/menuSwitch.vue"
import BaseInput from '~/components/base/baseInput'

export default {
  components: {
    MenuItem,
    MenuFill,
    MenuBackgroundImage,
    NavEdit,
    MenuSwitch,
    BaseInput
  },
  props: {
    site: Object,
    model: {
      type: Object,
      default: () => ({})
    }
  }
}
</script>

<style lang="less"></style>